// @flow
import React, { PureComponent } from 'react';
import type { CompetitionType } from 'types/Competition';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';
import CompetitionResultPool from 'containers/competition/CompetitionResultPoolContainer';
import Sidebar from 'components/sidebar/Sidebar';

type Props = {
  competition: CompetitionType
};

type ComponentState = {
  pouleId: number
};

class CompetitionResult extends PureComponent<Props, ComponentState> {
  state: ComponentState = {
    pouleId: 0
  };

  getPoules = () => {
    const { competition } = this.props;
    const array: Array<{label:string, value: string}> = competition.ranking.poules
      .sort((a, b) => a.pouleOrdre - b.pouleOrdre)
      .map(poules => ({
        label: `${competition.division.toUpperCase()} - POULE ${poules.pouleOrdre}`,
        value: poules.pouleId
      }));
    return array;
  };

  handleChange = (value: any) => {
    this.setState({
      pouleId: value
    });
  };

  render() {
    const { sidebar, ranking, slug } = this.props.competition;
    let { pouleId } = this.state;

    const poule = ranking.poules.find(({ pouleOrdre }) => parseInt(pouleOrdre, 10) === 1) || ranking.poules[0];
    pouleId = pouleId || (poule && poule.pouleId) || 0;

    return (
      <div className="container">
        <div className="row">
          <div className="col col-md-8 col-lg-9 bg-overflow">
            <section>
              <div className="row">
                <div className="col">
                  <div className="header-filter mt-5 mt-md-6">
                    <div className="row">
                      <div className="col col-lg-8on9">
                        <div className="header-filter__left">
                          {ranking.poules.length > 1 && (
                            <DropdownRadioInput
                              options={this.getPoules()}
                              inputChanged={this.handleChange}
                              radio={true}
                              maj={true}
                              title={true}
                              noBorder={true}
                            />
                          )}
                        </div>
                        <div className="header-filter__right">
                          {slug && (
                            <a
                              href={`https://competitions.ffr.fr/competitions/${slug}/`}
                              className="link-chevron link-chevron--blue"
                              data-label=""
                              target="blank"
                              rel="noopener noreferer"
                            >
                              <span>Accéder au site compétitions.ffr.fr</span>
                              <i className="icon icon-external"></i>
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="header-filter__sep mb-6"></div>
                </div>
              </div>
              <CompetitionResultPool pouleId={pouleId} />
            </section>
          </div>
          <Sidebar sidebarContent={sidebar} />
        </div>
      </div>
    );
  }
}

export default CompetitionResult;
